import styled from "styled-components"

import { useGetReferralAgentTrendsQuery } from "store/api/referralsApi"

import { Spinner } from "components/common/Spinner"

import { LinkFunnelCard } from "./LinkFunnelCard"
import { MonthlyPlacementsCard } from "./MonthlyPlacementsCard"
import { PlacementFunnelCard } from "./PlacementFunnelCard"
import { CardsRow, Section, SectionTitle } from "./shared"
import { ShareLinkCard } from "./ShareLinkCard"
import { TrendCard } from "./TrendCard"
import { buildTrendMetrics } from "./trendsData"

const TrendsMessage = styled.p`
  margin: 0;
  font-size: 14px;
  color: var(--text-muted);
`

const PageStack = styled.main`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const ReferralAgentDashboard = () => {
  const { data: trends, isLoading: isTrendsLoading, isError: isTrendsError } = useGetReferralAgentTrendsQuery()

  const renderTrends = () => {
    if (isTrendsLoading) return <Spinner />
    if (isTrendsError || !trends?.data) return <TrendsMessage>Trends are unavailable right now.</TrendsMessage>

    return buildTrendMetrics(trends.data).map(metric => <TrendCard key={metric.title} metric={metric} />)
  }

  return (
    <PageStack>
      <Section>
        <SectionTitle>Trends</SectionTitle>
        <CardsRow>{renderTrends()}</CardsRow>
      </Section>
      <Section>
        <SectionTitle>Your referral link</SectionTitle>
        <CardsRow>
          <ShareLinkCard />
          <LinkFunnelCard />
        </CardsRow>
      </Section>
      <Section>
        <SectionTitle>All referrals</SectionTitle>
        <CardsRow>
          <MonthlyPlacementsCard />
          <PlacementFunnelCard />
        </CardsRow>
      </Section>
    </PageStack>
  )
}
